<template>
  <div class="chat-widget-form mt-10">
    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 2fr) minmax(0, 1fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <!-- Left column: Configuration options -->
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:100%">
            <!-- Main configuration card -->
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Chat Widget
                    </h2>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                      Having more than one Whatsapp number? Our widget supports
                      multiple whatsapp numbers.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Enable Widget toggle -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Enable Widget
                    </h2>
                  </div>
                </div>
                <div class="mt-4">
                  <VSwitch v-model="config.widget.isEnabled" />
                </div>
              </div>

              <!-- Name and Phone Numbers -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Name and Phone Numbers
                    </h2>
                  </div>
                </div>

                <div class="mt-4">
                  <div
                    class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                  >
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Role
                          </th>
                          <th
                            scope="col"
                            class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Phone Number
                          </th>
                          <th scope="col" class="relative px-2 py-3"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="bg-white"
                          v-for="(number, index) in config.additionalAgents"
                          :key="index"
                        >
                          <td
                            class="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            {{ number.name }}
                          </td>
                          <td
                            class="px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            {{ number.description }}
                          </td>
                          <td
                            class="px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            {{ number.phoneNumber }}
                          </td>
                          <td
                            class="px-2 py-4 whitespace-nowrap text-right text-sm font-medium"
                          >
                            <a
                              class=" hover:text-indigo-900 mx-2 cursor-pointer"
                              @click="editNumber(number, index)"
                              >Edit</a
                            >
                            <a
                              class=" hover:text-indigo-900 cursor-pointer"
                              @click="deleteNumber(index)"
                              >Delete</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="mt-4" v-if="showAddNumberForm === false">
                  <button
                    class="Polaris-Button"
                    type="button"
                    @click="openNewNumberModal"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text"
                        >Add Another Number</span
                      >
                    </span>
                  </button>
                </div>
              </div>

              <!-- Widget Appearance -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Widget Appearance
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid Polaris-FormLayout--condensed mt-4"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(2, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <!-- Header Color -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Header Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField relative">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="config.colors.widgetHeaderColor"
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="config.colors.widgetHeaderColor"
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Header Text Color -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Header Text Color</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField relative">
                              <input
                                class="Polaris-TextField__Input hasColor"
                                v-model="config.colors.widgetHeaderTextColor"
                                type="text"
                              />
                              <verte
                                picker="square"
                                v-model="config.colors.widgetHeaderTextColor"
                                class="colorPicker"
                                model="hex"
                              ></verte>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Widget Title -->
                    <div class="Polaris-FormLayout__Item mt-4">
                      <div class="Polaris-Labelled__LabelWrapper">
                        <div class="Polaris-Label">
                          <label class="Polaris-Label__Text"
                            >Header title</label
                          >
                        </div>
                      </div>
                      <div class="Polaris-Connected">
                        <div
                          class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                        >
                          <div class="Polaris-TextField">
                            <input
                              class="Polaris-TextField__Input"
                              v-model="config.texts.widgetTitle"
                              type="text"
                            />
                            <div class="Polaris-TextField__Backdrop"></div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="hasMoreTitleCharacters"
                        class="Polaris-InlineError"
                      >
                        <div class="Polaris-InlineError__Icon">
                          <span class="Polaris-Icon">
                            <svg
                              viewBox="0 0 20 20"
                              class="Polaris-Icon__Svg"
                              focusable="false"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zM9 6a1 1 0
                              0 1 2 0v4a1 1 0 1 1-2 0V6zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                              ></path>
                            </svg>
                          </span>
                        </div>
                        Widget title should be less than 20 characters
                      </div>
                    </div>

                    <!-- Widget Description -->
                    <div class="Polaris-FormLayout__Item mt-4">
                      <div class="Polaris-Labelled__LabelWrapper">
                        <div class="Polaris-Label">
                          <label class="Polaris-Label__Text"
                            >Header description</label
                          >
                        </div>
                      </div>
                      <div class="Polaris-Connected">
                        <div
                          class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                        >
                          <div class="Polaris-TextField">
                            <input
                              class="Polaris-TextField__Input"
                              v-model="config.texts.widgetDescription"
                              type="text"
                            />
                            <div class="Polaris-TextField__Backdrop"></div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="hasMoreDescriptionCharacters"
                        class="Polaris-InlineError"
                      >
                        <div class="Polaris-InlineError__Icon">
                          <span class="Polaris-Icon">
                            <svg
                              viewBox="0 0 20 20"
                              class="Polaris-Icon__Svg"
                              focusable="false"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zM9 6a1 1 0
                              0 1 2 0v4a1 1 0 1 1-2 0V6zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                              ></path>
                            </svg>
                          </span>
                        </div>
                        Widget Description should be less than 70 characters
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Save Button -->
              <!-- <div class="Polaris-LegacyCard__Section">
                <div class="flex justify-end">
                  <button
                    class="Polaris-Button Polaris-Button--primary"
                    type="button"
                    @click="update"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text">Save</span>
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Right column: Preview -->
      <div class="chat-widget-preview-column">
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                  Widget Preview
                </h2>
                <div
                  class="mt-6 p-4 border rounded bg-gray-50 flex justify-center"
                >
                  <WidgetPreview :config="config" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AddNewNumberModal
      v-if="showAddNumberForm"
      :agent="currentNumberToEdit"
      @close="closeModal"
      @create="addNewNumber"
      @update="updateNumber"
    />
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";
import Verte from "verte";
import AddNewNumberModal from "./AddNumberModal";
import WidgetPreview from "./WidgetPreview";

export default {
  name: "AdditionalAgents",
  components: {
    Verte,
    VSwitch,
    AddNewNumberModal,
    WidgetPreview
  },
  data() {
    return {
      newNumber: null,
      showAddNumberForm: false,
      form: {
        number: null,
        name: "",
        description: ""
      },
      currentNumberToEdit: null,
      currentEditIndex: null
    };
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasMoreTitleCharacters() {
      const label = this.config.texts.widgetTitle;
      return label.length > 20;
    },
    hasMoreDescriptionCharacters() {
      const label = this.config.texts.widgetDescription;
      return label.length > 70;
    }
  },
  mounted() {
    const config = this.config;
    if (
      config &&
      config.additionalAgents &&
      config.additionalAgents.length === 0 &&
      config.phoneNumber &&
      config.phoneNumber.length > 0
    ) {
      this.config.additionalAgents.push({
        name: "Customer care",
        description: "Chat with us",
        avatarUrl:
          "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/avatar-male.svg?v=1614858646",
        phoneNumber: config.phoneNumber,
        isEnabled: true
      });
    }
  },
  methods: {
    handlePhoneNumberUpdate(event, index) {
      console.log({ event, index });
    },
    update() {
      if (this.hasMoreTitleCharacters) {
        alert("widget title should be less than 20 characters");
        return;
      }
      if (this.hasMoreDescriptionCharacters) {
        alert("widget description should be less than 70 characters");
        return;
      }
      this.$emit("save");
    },
    addNewNumber({ name, description, phoneNumber, avatarUrl }) {
      this.config.additionalAgents.push({
        name,
        description,
        phoneNumber,
        avatarUrl,
        isEnabled: true
      });
      this.showAddNumberForm = false;
    },
    updateNumber({ name, description, phoneNumber, avatarUrl }) {
      this.config.additionalAgents[this.currentEditIndex] = {
        name,
        description,
        phoneNumber,
        avatarUrl,
        isEnabled: true
      };
      this.showAddNumberForm = false;
    },
    editNumber(number, index) {
      this.currentNumberToEdit = number;
      this.currentEditIndex = index;
      this.showAddNumberForm = true;
    },
    deleteNumber(index) {
      this.config.additionalAgents.splice(index, 1);
    },
    closeModal() {
      this.showAddNumberForm = false;
    },
    openNewNumberModal() {
      this.currentNumberToEdit = null;
      this.currentEditIndex = null;
      this.showAddNumberForm = true;
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 4px;
  left: 8px;
  z-index: 100;
}

/* Target the color picker when it's active/open */
.verte.colorPicker .verte__menu-origin--active {
  z-index: 10000 !important;
}

/* Also ensure the parent element has higher z-index when active */
.verte.colorPicker:has(.verte__menu-origin--active) {
  z-index: 10000 !important;
}

/* For browsers that don't support :has selector */
.Polaris-Connected__Item--primary:focus-within .verte.colorPicker,
.Polaris-Connected__Item--primary:hover .verte.colorPicker {
  z-index: 10000 !important;
}

.Polaris-TextField__Input.hasColor {
  padding-left: 42px;
}

.chat-widget-form .Polaris-LegacyCard {
  overflow: visible;
}

.chat-widget-form .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.chat-widget-form .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}

@media (min-width: 768px) {
  .chat-widget-preview-column {
    position: sticky;
    top: 1.5rem;
    align-self: flex-start;
  }
}
</style>
